import { render } from "./EdicionRouter.vue?vue&type=template&id=a748ae7e&scoped=true"
import script from "./EdicionRouter.vue?vue&type=script&lang=js"
export * from "./EdicionRouter.vue?vue&type=script&lang=js"

import "./EdicionRouter.vue?vue&type=style&index=0&id=a748ae7e&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a748ae7e"]])

export default __exports__